<template>
    <div :class="['base-modal',{'focus':focus}]">
        <div @click="toggleModal()" class="text-btn">{{btnText}}</div>

        <div v-show="showModal" class="bg-effect"></div>
        <div v-show="showModal" @mousedown="closeModal(true)" class="base-modal-content-wrap">
            <div @mouseenter="hover = true"
                 @mouseleave="hover = false"
                 class="base-modal-content">

                <div class="close-icon-wrap">
                    <svg @click="closeModal()" class="close-icon">
                        <use xlink:href="../../assets/images/sprite.svg#close"></use>
                    </svg>
                </div>

                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "modal",
        data() {
            return {
                showModal: false,
                hover: false,
                focus:false
            }
        },
        props: {
            btnText: {
                type: String,
                default: ""
            },
            value: {
                type: Boolean,
                default: false
            },
            parentFocus: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            }
        },
        created() {
            addEventListener("keydown",this.keydown)
        },
        mounted() {
            this.showModal = this.value
        },
        methods: {
            toggleModal() {
                this.showModal = !this.showModal;
            },
            closeModal(hovered = false) {
                if(this.loading) return;
                
                if (hovered) {
                    if (!this.hover) {
                        this.showModal = false;
                    }
                    return
                }
                this.showModal = false;
            },
            keydown(e){
                if (e.keyCode===13 && this.focus)
                {
                    this.closeModal();
                }
            }
        },
        beforeDestroy() {
            const html = document.getElementsByTagName("html")[0];
            html.style.overflowY = "auto";
            removeEventListener("keydown", this.keydown)
        },
        watch: {
            showModal(val) {
                const html = document.getElementsByTagName("html")[0];
                html.style.overflowY = val ? "hidden" : "auto";
                this.$emit("input", val);
                // this.$emit("change", val)
            },
            value(val) {
                this.showModal = val
            },
            parentFocus(val){
                this.focus=val;
            }
        }
    }
</script>

<style scoped>
    .base-modal .text-btn {
        font-weight: 500;
        font-size: 13px;
        line-height: 15px;
        color: var(--white-color);
        cursor: pointer;
    }
    .base-modal .bg-effect {
        z-index: 100;
    }
    .base-modal .base-modal-content-wrap {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        overflow: auto;
        z-index: 101;
        height: 100vh;
        padding: 50px;
    }
    .base-modal .base-modal-content {
        position: relative;
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        width: 500px;
        border-radius: 4px;
        background-color: var(--white-color);
        z-index: 12;
        margin: 0 auto;
    }
    .base-modal .base-modal-content .close-icon{
        fill: #aaa;
        cursor: pointer;
        transition: all .2s;
        width: 16px;
        height: 16px;
    }
    .base-modal.focus .base-modal-content .close-icon-wrap{
        border: 2px solid black;
        padding: 2px;
        border-radius: 5px;
    }
    .base-modal .base-modal-content .close-icon-wrap{
        position: absolute;
        top: 20px;
        right: 20px;
    }
    .base-modal .base-modal-content .close-icon:hover{
        fill: #333;
    }
</style>
